import React, { useState, useEffect, useContext } from "react";
import EmployeeCard from "../../sub-components/managerEmpSub/EmployeeCard";
import axios from "axios";
import { GET_COMPANY_PEOPLE } from "../../../Routes";
import { generateURLOptions } from "../../../URLOptions";
import FadeIn from "react-fade-in";
import { UserContext } from "../../../storage/contexts/UserContext";
import FilledButton from "../../../InterstellrComponents/FilledButton";
import PeopleActionsModal from "../../../InterstellrModals/PeopleActionsModal";
import UserResetPasswordModal from "../../../InterstellrModals/UserResetPasswordModal";
import EventBus from "../../../storage/EventBus";
import AddPersonModal from "../../../InterstellrModals/AddPersonModal";

const PeopleDirectory = () => {
  const { profile } = useContext(UserContext);
  const [isLoading, setIsLoading] = useState(true);
  const [people, setPeople] = useState([]);

  const [peopleOptionsOpen, setPeopleOptionsOpen] = useState(false);
  const [selectedPerson, setSelectedPerson] = useState(null);

  const [passwordResetOpen, setPasswordResetOpen] = useState(false);

  const [showAddPerson, setShowAddPerson] = useState(false);

  useEffect(() => {
    getPeople();
  }, []);

  const getPeople = async () => {
    try {
      const response = await axios.get(GET_COMPANY_PEOPLE, {
        headers: generateURLOptions(),
      });
      console.log("PEOPLE RESPONSE: ", JSON.stringify(response.data.data));
      if (response?.data?.success === false) {
        alert(response?.data?.message ?? "");
        return;
      }

      setPeople(response?.data?.data);
      setIsLoading(false);
    } catch (error) {
      console.error("Organiation People Error: ", error);
      return alert(error);
    }
  };

  return (
    <>
      <PeopleActionsModal
        isOpen={peopleOptionsOpen}
        onClose={() => {
          setPeopleOptionsOpen(false);
          EventBus.emit("updateProfile");
        }}
        person={selectedPerson}
        onUpdate={getPeople}
        onChangePassword={() => {
          setPeopleOptionsOpen(false);
          setPasswordResetOpen(true);
        }}
      />

      <AddPersonModal
        isOpen={showAddPerson}
        onClose={() => {
          setShowAddPerson(false);
          getPeople();
          EventBus.emit("updateProfile");
        }}
        profile={profile}
      />

      <UserResetPasswordModal
        isOpen={passwordResetOpen}
        onClose={() => setPasswordResetOpen(false)}
        person={selectedPerson}
        onUpdate={getPeople}
      />

      <div className="relative">
        <div
          className="z-0 absolute top-0 bottom-0 left-0 right-0"
          style={{
            background: `linear-gradient(45deg, rgba(255,255,255,0.8) 0%, rgba(255,255,255,0.8) 45%, ${
              profile?.company_id
                ? profile?.company_id?.company_primary_color
                : "rgba(81, 83, 245, 1)"
            } 150%)`,
          }}
        />

        {!isLoading ? (
          <FadeIn className="overflow-hidden" delay={250}>
            <div className="relative z-[20] pt-12 w-full md:w-2/3 mx-auto px-6 md:px-0 pb-12">
              {/* Search Header */}
              <div className="flex flex-row justify-center items-center">
                <div className="flex flex-col">
                  <h4 className="font-medium text-xl">People Directory</h4>

                  <p className="mb-0 font-medium text-black text-base">
                    {profile?.company_id?.usedSeats ?? 0} /{" "}
                    {profile?.company_id?.seats ?? 0} Seats
                  </p>
                </div>

                <div style={{ flex: 1 }} />

                <div className="w-1/5">
                  <FilledButton
                    text={"Add Person"}
                    onPress={() => setShowAddPerson(true)}
                  />
                </div>
              </div>

              {people?.length > 0 ? (
                people?.map((person) => (
                  <EmployeeCard
                    key={person?._id}
                    person={person}
                    onOptions={(value) => {
                      setSelectedPerson(value);
                      setPeopleOptionsOpen(true);
                    }}
                  />
                ))
              ) : (
                <span className="validation_text_invalid">
                  You currently haven't added anyone to your Team
                </span>
              )}
            </div>
          </FadeIn>
        ) : (
          <FadeIn className="overflow-hidden">
            <div className="h-[90vh] relative flex flex-col justify-center items-center z-50">
              <div
                className="h-10 w-10 rounded-full border-4 border-mpPurple/30 border-t-mpPurple animate-spin"
                style={{ marginTop: 12, marginBottom: 12 }}
              />

              <h6 className="text-black font-medium">
                Updating your organisation
              </h6>
            </div>
          </FadeIn>
        )}
      </div>
    </>
  );
};

export default PeopleDirectory;
